/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Err_RecipientInputs */

const en_messages_err_recipient = /** @type {(inputs: Messages_Err_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick who this goes to.`)
};

const he_messages_err_recipient = /** @type {(inputs: Messages_Err_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחר למי זה נשלח.`)
};

/**
* | output |
* | --- |
* | "Pick who this goes to." |
*
* @param {Messages_Err_RecipientInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_err_recipient = /** @type {((inputs?: Messages_Err_RecipientInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Err_RecipientInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_err_recipient(inputs)
	return he_messages_err_recipient(inputs)
});